import {defineMessages} from 'react-intl';

export const studentMessages = defineMessages({
  emptyContent: {
    id: 'student.empty_content',
  },
  emptyItem: { id: 'student.empty_item' },
});
